import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { GridApi, GridOptions } from 'ag-grid';

import { Vehiculo } from '../Models/Vehiculo';
import { Usuario } from '../Models/Usuario';

import { VehiculoService } from '../services/vehiculo.service';
import { GlobalsService } from '../services/globals.service';


@Component({
  selector: 'app-vehiculo',
  templateUrl: './vehiculo.component.html',
  styleUrls: ['./vehiculo.component.css']
})
export class VehiculoComponent implements OnInit {


  public vehiculo: Vehiculo = new Vehiculo();
  public vehiculos: Vehiculo[];

  public modoEdicion: boolean = false;
  public nuevoRegistro: boolean = false;
  //grid
  private gridOptions = <GridOptions>{};
  private gridApi;
  private gridColumnApi;


  @ViewChild('agGrid') agGrid: AgGridNg2;
  title = 'Vehiculos';

  columnDefs = [
    { headerName: 'Placa', field: 'idvehiculo', icons: { filter: ' ' } },
    { headerName: 'Descripción', field: 'descripcion', icons: { filter: ' ' } },
    { headerName: 'Tipo Vehículo', field: 'tipovehiculo', icons: { filter: ' ' } },
    //  {headerName: 'Tipo Combustible', field: 'tipocombustible'},
    // {headerName: 'Marca', field: 'marca'},
    { headerName: 'Modelo', field: 'modelo', icons: { filter: ' ' } }

  ];

  rowData: any[];

  constructor(private vehiculoService: VehiculoService, private globalServices: GlobalsService) {
    this.gridOptions.columnDefs = this.columnDefs;

    // this.gridOptions.rowData= this.rowData;

  }

  ngOnInit() {

    this.modoEdicion = false;

    this.CargarVehiculos();

  }

//carga los vehiculos de la compañia
  CargarVehiculos() {
    try {

      this.vehiculoService.ObtenerVehiculos(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.vehiculos = data;
          //grid
          this.rowData = this.vehiculos;
          this.gridOptions.rowData = this.rowData;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVehiculos: " + error);
    }
  }

//Inserta o actualiza el vehiculo
  GuardarRegistro() {

    this.vehiculo.idcompania = this.globalServices.ObtenerCompania();

    this.vehiculoService.GuardarRegistro(this.vehiculo).subscribe(

      data => {

        swal("Registro guardado con éxito!", "", "success");

        this.vehiculo = new Vehiculo();
        this.modoEdicion = false;

        this.CargarVehiculos();

      },
      err => {
        console.log("GuardarRegistro: " + err);
      }

    );


  }

  NuevoRegistro() {
    this.nuevoRegistro = true;
    this.vehiculo = new Vehiculo();
    this.modoEdicion = true;
  }

  CancelarEdicion() {
    this.vehiculo = new Vehiculo();
    this.modoEdicion = false;
  }



//click en el row de la tabla
  private onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
   

    let datos = JSON.parse(JSON.stringify($event.data));

    this.nuevoRegistro = false;
    this.vehiculo = datos;
    this.modoEdicion = true;

  }


}

